import { useState, useEffect, useRef } from "react";
import axios from "axios";

import { Button, Modal, Text, Indicator, Loader } from "@mantine/core";
import { useForm } from "@mantine/form";
import Comp_Cafe_POS_3_1_1 from "../Component/Comp_Cafe_POS_3_1_1";
import Comp_Cafe_POS_3_1_2 from "../Component/Comp_Cafe_POS_3_1_2";
import Comp_Cafe_POS_3_1_3 from "../Component/Comp_Cafe_POS_3_1_3";
import Comp_Cafe_POS_3_2_2 from "../Component/Comp_Cafe_POS_3_2_2";
import Comp_Cafe_POS_3_2_3 from "../Component/Comp_Cafe_POS_3_2_3";
import Comp_Cafe_POS_3_3_1 from "../Component/Comp_Cafe_POS_3_3_1";
import Comp_Cafe_POS_3_3_2 from "../Component/Comp_Cafe_POS_3_3_2";
import Comp_Cafe_POS_3_3_3 from "../Component/Comp_Cafe_POS_3_3_3";
import Comp_CafeMap from "../Component/Comp_CafeMap";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

const Page_HeroesNeverDie = () => {
  const [DB_CafeZdmx_SyncStatus, setDB_CafeZdmx_SyncStatus] = useState([]);
  const get_DB_CafeZdmx_SyncStatus = async (cafe) => {
    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/get_eclipse_awesome_pos__zdmx__syncstatus`,
        {
          cafe,
        }
      )
      .then((res) => {
        console.log("get_DB_CafeZdmx_SyncStatus", res?.data);

        setDB_CafeZdmx_SyncStatus(res?.data);
      });
  };

  //  ----------------------------------------------------------------------------------------- database
  const [cafeList, setCafeList] = useState([
    "Gift BBA",
    "Gift BBK",
    "Gift BukitAngsana",
    "Gift CherasPerdana",
    "Gift EquinePark",
    "Gift Evesuite",
    "Gift Impian",
    "Gift KajangIndah",
    "Gift Kepong Baru",
    "Gift KotaDamansara",
    "Gift LembahMaju",
    "Gift Manjalara",
    "Gift Nirwana",
    "Gift OUG",
    "Gift PandanIndah",
    "Gift Serdang",
    "Gift SGBuloh",
    "Gift ShahAlam",
    "Gift SriManja",
    "Gift SungaiLong",
    "Gift Suntek",
    "Redsea PS",
    "Redsea PV12",
    "Redsea TBR",
    "Redsea Wangsa Maju",
  ]);

  //----------------------------------------------------------------------------------------- handle form

  const [isSubmitting, setIsSubmitting] = useState(false);
  const input1Ref = useRef(null);
  const input2Ref = useRef(null);

  const form = useForm({
    initialValues: {
      input1: "",
      input2: "",
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevent double submission
    setIsSubmitting(true);

    const values = {
      input1: input1Ref.current.value,
      input2: input2Ref.current.value,
    };

    console.log("Form Submitted:", values);

    setTimeout(() => {
      // alert("done");
      setIsSubmitting(false);
      form.reset();
    }, 500);
  };

  //----------------------------------- global variable
  const [showCafePCMap, setShowCafePCMap] = useState(false); // devMode = false

  const [modal1_Opened, setModal1_Opened] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);

  const [selectedPresentationOption, setSelectedPresentationOption] =
    useState("selected_cafe");
  const [selectedPresentationCafe, setSelectedPresentationCafe] = useState(""); // devMode = ""

  const [selectedPresentationMode, setSelectedPresentationMode] = useState(""); // devMode def = ''

  const formatSecondsToDH = (seconds) => {
    const dur = dayjs.duration(seconds, "seconds");
    const d = dur.days();
    const h = dur.hours();

    let result = [];
    if (d > 0) result.push(`${d}d`);
    if (h > 0 || result.length === 0) result.push(`${h}h`);
    return result.join(" ");
  };

  useEffect(() => {
    get_DB_CafeZdmx_SyncStatus();
  }, []);

  return (
    <div className="CM_Body">
      Page Cafe POS - Zone Status Reports 📌Still in developing stage, if hang
      just reopen new tab, if loading slow reload the page do 1 task a time
      📌Resource heavy, on going finetune
      <br />
      <Text component="div">
        <h2>1. Select</h2>
      </Text>
      <div className="CM_Padding_Left_Rigth_3rem">
        <Button
          // size="lg"
          variant={
            selectedPresentationOption == "all_cafe" ? "filled" : "outline"
          }
          color="orange"
          onClick={() => {
            setSelectedPresentationOption("all_cafe");
          }}
        >
          Show All Cafes (coming soon)
        </Button>
        <Button
          // size="lg"
          variant={
            selectedPresentationOption == "selected_cafe" ? "filled" : "outline"
          }
          color="orange"
          onClick={() => {
            setSelectedPresentationOption("selected_cafe");
          }}
        >
          Show Selected Cafe
        </Button>
      </div>
      <Modal
        centered
        opened={modal1_Opened}
        onClose={() => setModal1_Opened(false)}
        title=""
      >
        <h1>Zone PCs Info</h1>
        {`Date : ${selectedItem?.dateby_day}`}
        <br />
        <br />
        {`Cafe : ${selectedItem?.cafe}`}
        <br />
        <br />
        {`Pc Zone : ${selectedItem?.pczone_info}`}
        <br />
        <br />
        {`Total Minutes (Usage) : ${selectedItem?.total_min}`}
        <br />
        <br />
        {`PC Total : ${selectedItem?.pcs_info?.split(",")?.length}`}
        <br />
        {`PC List : ${selectedItem?.pcs_info}`}
        <br />
        <br />
        {`Average Occupy Rate  : ${selectedItem?.avg_occupy_rate}`}
        <br />
        <br />
        *** Average Occupy Rat = total Minutes (Usage) / ( Pc Total * 24 * 60 )
        ={" "}
        {`${selectedItem?.total_min} / ${
          selectedItem?.pcs_info?.split(",")?.length
        } * 24 * 60`}
      </Modal>
      <br />
      {selectedPresentationOption == "all_cafe" ? (
        <>{console.log("render time")}</>
      ) : null}
      {/* {`selectedPresentationCafe: ${
        selectedPresentationCafe == "" ? "Loading..." : selectedPresentationCafe
      }`} */}
      <h2>2. Select Cafe </h2>
      {selectedPresentationOption == "selected_cafe" ? (
        <>
          <div className="CM_Padding_Left_Rigth_3rem ">
            <div className="CM_Flex_Container_Type1">
              {cafeList?.map((x, i) => (
                <Indicator
                  key={i}
                  disabled={
                    DB_CafeZdmx_SyncStatus?.filter((y) => y?.cafe === x)?.[0]
                      ?.dur_sec >
                    60 * 60 * 24
                      ? false
                      : true
                  }
                  position="bottom-center"
                  color="red"
                  // withBorder
                  processing
                  inline
                  size={12}
                  label={`Offiline : ${formatSecondsToDH(
                    DB_CafeZdmx_SyncStatus?.filter((y) => y?.cafe === x)?.[0]
                      ?.dur_sec
                  )}`}
                >
                  <Button
                    className="CM_Flex_Item_Type1"
                    key={i}
                    // size="lg"
                    color="orange"
                    variant={
                      selectedPresentationCafe == x ? "filled" : "outline"
                    }
                    onClick={() => {
                      setSelectedPresentationCafe(x);
                      // get_DB_CafeList_ByCafe(x);
                      // get_DB_CafePCList_ByCafe(x);
                    }}
                  >
                    {`${i + 1}. ${x}  `}
                  </Button>
                </Indicator>
              ))}
            </div>
            <div className="FlexColumn">
              {DB_CafeZdmx_SyncStatus?.length > 0 ? null : (
                <Loader color="red" size="xs" type="bars" />
              )}
            </div>
            <br />
            <br />
            <Button
              color="lime"
              variant={showCafePCMap ? "filled" : "subtle"}
              onClick={() => {
                setShowCafePCMap(!showCafePCMap);
              }}
            >
              {showCafePCMap === false
                ? `⛩️ Show Cafe PC MAP`
                : `⛩️ Hide Cafe PC MAP`}
            </Button>
            {showCafePCMap ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "1rem",
                  border: "2px dotted darkgreen",
                }}
              >
                <div
                  style={{
                    overflow: "auto",
                    maxWidth: "100%",
                  }}
                >
                  {/* `https://chatgpt.com/c/683f8e82-a1c4-8010-b46b-155119ae916f` */}
                  <Comp_CafeMap
                    selectedPresentationCafe={selectedPresentationCafe}
                  />
                </div>
              </div>
            ) : null}
          </div>
          <br />
          {selectedPresentationCafe != "" ? (
            <div>
              <h2>3. Select Presentation</h2>
              <div className="CM_Padding_Left_Rigth_3rem">
                <h3>PC Usage</h3>

                <div className="CM_Grid_4x1fr ">
                  <div>3.1. Group By PC (measure by time)</div>
                  <Button
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.1.1" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.1.1")}
                  >
                    3.1.1. Hourly
                  </Button>
                  <Button
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.1.2" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.1.2")}
                  >
                    3.1.2. Daily
                  </Button>
                  <Button
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.1.3" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.1.3")}
                  >
                    3.1.3. Monthly
                  </Button>
                </div>
                <div className="CM_Grid_4x1fr">
                  <div>3.2. Group By PC Zone (measure by time)</div>
                  <div></div>

                  <Button
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.2.2" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.2.2")}
                  >
                    3.2.2. Daily
                  </Button>
                  <Button
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.2.3" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.2.3")}
                  >
                    3.2.3. Monthly
                  </Button>
                </div>
                <div className="CM_Grid_4x1fr">
                  {/* <div>3.3. Group By PC Zone (measure by pc amount)</div> */}
                  <div>3.3. Group By PC Zone (Full House Rate)</div>
                  <Button
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.3.1" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.3.1")}
                  >
                    3.3.1. Hourly
                  </Button>
                  <Button
                    // disabled
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.3.2" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.3.2")}
                  >
                    3.3.2 - Daily
                  </Button>
                  <Button
                    // disabled
                    color="orange"
                    variant={
                      selectedPresentationMode == "3.3.3" ? "filled" : "outline"
                    }
                    onClick={() => setSelectedPresentationMode("3.3.3")}
                  >
                    3.3.3 - Monthly
                  </Button>
                </div>
              </div>
            </div>
          ) : null}

          <br />
          <hr />
          <hr />
          <br />
          {/* {`presentationMode= : ${selectedPresentationMode}`} */}

          {selectedPresentationMode == "3.1.1" &&
          selectedPresentationCafe != "" ? (
            <Comp_Cafe_POS_3_1_1
              // key="Comp_Cafe_POS_HeatMap_Hourly"
              selectedPresentationCafe={selectedPresentationCafe}
            />
          ) : null}

          {selectedPresentationMode == "3.1.2" &&
          selectedPresentationCafe != "" ? (
            <div
              style={{
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <Comp_Cafe_POS_3_1_2
                // key="Comp_Cafe_POS_HeatMap_Daily"
                selectedPresentationCafe={selectedPresentationCafe}
              />
            </div>
          ) : null}

          {selectedPresentationMode == "3.1.3" &&
          selectedPresentationCafe != "" ? (
            <div
              style={{
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <Comp_Cafe_POS_3_1_3
                // key="Comp_Cafe_POS_HeatMap_Monthly"
                selectedPresentationCafe={selectedPresentationCafe}
              />
            </div>
          ) : null}

          {selectedPresentationMode == "3.2.2" ? (
            <div
              style={{
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <Comp_Cafe_POS_3_2_2
                // key="Comp_Cafe_POS_HeatMap_Daily_ByZone"
                selectedPresentationCafe={selectedPresentationCafe}
              />
            </div>
          ) : null}

          {selectedPresentationMode == "3.2.3" ? (
            <div
              style={{
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <Comp_Cafe_POS_3_2_3
                // key="Comp_Cafe_POS_HeatMap_Monthly_ByZone"
                selectedPresentationCafe={selectedPresentationCafe}
              />
            </div>
          ) : null}

          {selectedPresentationMode == "3.3.1" ? (
            <div
              style={{
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <Comp_Cafe_POS_3_3_1
                // key="Comp_Cafe_POS_HeatMap_Hourly_ByZone_TotalPC"
                selectedPresentationCafe={selectedPresentationCafe}
              />
            </div>
          ) : null}
          {selectedPresentationMode == "3.3.2" ? (
            <div
              style={{
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <Comp_Cafe_POS_3_3_2
                // key="Comp_Cafe_POS_HeatMap_Daily_ByZone_TotalPC"
                selectedPresentationCafe={selectedPresentationCafe}
              />
            </div>
          ) : null}
          {selectedPresentationMode == "3.3.3" ? (
            <div
              style={{
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <Comp_Cafe_POS_3_3_3
                // key="Comp_Cafe_POS_HeatMap_Monthly_ByZone_TotalPC"
                selectedPresentationCafe={selectedPresentationCafe}
              />
            </div>
          ) : null}
        </>
      ) : null}
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Page_HeroesNeverDie;
